import {
  Form,
  Input,
  Button,
  Flex,
  Typography
} from "antd";
import { UserOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { Trans, useTranslation } from "react-i18next";
import useSignIn from "./useSignIn";
import { appRoutes } from "../../constants/routes";

const { Text } = Typography;

const SignIn = () => {
  const { t } = useTranslation();
  const {
    onFinish,
    loading,
    passwordVisible,
    setPasswordVisible
  } = useSignIn();

  return (
    <Form
      name="signin"
      initialValues={{ remember: true }}
      onFinish={onFinish}
      style={{ maxWidth: 459, width: "100%" }}
    >
      <Form.Item
        name="username"
        rules={[{ required: true, message: t("form.error.email") }]}
      >
        <Input prefix={<UserOutlined style={{ color: "rgba(0,0,0,.45)" }} />} placeholder="E-mail" />
      </Form.Item>
      <Form.Item
        name="password"
        rules={[{ required: true, message: t("form.error.password") }]}
      >
        <Input.Password
          placeholder="Password"
          visibilityToggle={{ visible: passwordVisible, onVisibleChange: setPasswordVisible }}
        />
      </Form.Item>
      <Form.Item>
        <Flex justify="space-between">
          {/* <Form.Item name="remember" valuePropName="checked" noStyle> */}
          {/*  <Checkbox>Ricorda password</Checkbox> */}
          {/* </Form.Item> */}
          <Link to={appRoutes.resetPassword}>{t("loginPage.resetPasswordLink")}</Link>
        </Flex>
      </Form.Item>

      <Form.Item>
        <Button
          type="primary"
          htmlType="submit"
          disabled={loading}
          loading={loading}
          block
        >
          {t("loginPage.loginButton")}
        </Button>
      </Form.Item>
      <Text style={{ textAlign: "center", display: "block" }}>
        <Trans
          i18nKey="loginPage.noAccount"
          components={{ linkWrap: <Link to={appRoutes.signUp} /> }}
        />
      </Text>
    </Form>
  );
};

export default SignIn;
